import React from "react";

import * as S from "./styles";

const Banner: React.FC = () => {
  return (
    <S.Container>
      <S.Content className="left" />
      <S.Content className="mobile">
        <S.ImageGirl
          className="wow animate__animated animate__zoomIn"
          data-wow-duration="1s"
        />
      </S.Content>
      <S.Content className="right">
        <S.Title
          className="wow animate__animated animate__fadeInDown"
          data-wow-duration="1s"
        >
          ELLE e Tiffany & Co. apresentam: Thai de Melo
        </S.Title>
        <S.Text
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="300ms"
        >
          A influencer mais <br />
          bem-humorada do mundo
          <br />
          da moda fala sobre amor,
          <br /> felicidade, amizade e força:
          <br />
          os temas da coleção T de
          <br />
          Tiffany & Co.
        </S.Text>
      </S.Content>
    </S.Container>
  );
};

export default Banner;
